/**
 * Invokers API (button.commandfor / command) の軽量 polyfill (iOS Safari < 18.4 等向け)。
 * dialog.showModal / close 自体は Safari 15.4+ サポート済みでフォールバック先として安全。
 */

/**
 * @returns {void}
 */
export function setupInvokersPolyfill() {
  if ('command' in HTMLButtonElement.prototype) return;

  document.addEventListener('click', e => {
    if (!(e.target instanceof Element)) return;
    const btn = e.target.closest('button[commandfor]');
    if (!(btn instanceof HTMLButtonElement)) return;
    const id = btn.getAttribute('commandfor');
    if (!id) return;
    const dialog = document.getElementById(id);
    if (!(dialog instanceof HTMLDialogElement)) return;
    const cmd = btn.getAttribute('command');
    if (cmd === 'show-modal') dialog.showModal();
    else if (cmd === 'close') dialog.close();
  });
}
